import {put, takeLatest, call} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {get} from 'lodash';
import {PHONE_DIAL_CODE} from '@app/utils/constants';
import {encodePassword} from '@app/utils/helpers';
import {
  fetchUserByUUIDRequest,
  fetchUserByUUIDSuccess,
  fetchUserByUUIDError,
  createUserRequest,
  createUserSuccess,
  createUserError,
  setRedirect,
  createCorporateSuccess,
  createCorporateError,
} from './index';

import {fetchUserByUUID, createUser, createCorporate} from './api';

export const sagaActions = {
  FETCH_USER_BY_UUID: 'FETCH_USER_BY_UUID',
  CREATE_USER: 'CREATE_USER',
  CREATE_CORPORATE: 'CREATE_CORPORATE',
};

function* fetchUserByUUIDSaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchUserByUUIDRequest());
    const result = yield call(fetchUserByUUID, values.uuid);
    if (!result.error) {
      yield put(fetchUserByUUIDSuccess(result.data));
    } else {
      yield put(fetchUserByUUIDSuccess({error: result.error}));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchUserByUUIDError(message));
    } else {
      toast.error(e.error);
      yield put(fetchUserByUUIDError(e.error));
    }
  }
}

function* createUserSaga({payload}) {
  const {values, redirect, token} = payload;
  try {
    yield put(createUserRequest());
    const requestPayload = {
      title: values.title.value,
      position: values.position,
      firstName: values.firstName,
      middleName: values.middleName,
      lastName: values.lastName,
      email: values.email,
      phone: `${PHONE_DIAL_CODE}${values.phone}`,
      password: encodePassword(values.password),
      termsAgreed: true,
    };
    const result = yield call(createUser, requestPayload, token);
    if (!result.error) {
      yield put(createUserSuccess(result));
      toast.success(result.message);
      if (redirect) {
        yield put(setRedirect('UserRegister'));
      }
    } else if (result.error) {
      toast.error(result.error);
      yield put(createUserError(result.error));
    }
  } catch (e) {
    if (e.error) toast.error(e.error);
    yield put(createUserError(e));
  }
}

function* createCorporateSaga({payload}) {
  const {values, redirect, token} = payload;
  try {
    yield put(createCorporateSuccess());
    const requestPayload = {
      name: values.corporateName,
      commercialRegistration: values.entityCRNumber,
      tradingName: values.tradingName,
      streetAddress: values.streetAddress,
      postalAddress: values.postalAddress,
    };
    const result = yield call(createCorporate, requestPayload, token);
    if (!result.error) {
      yield put(createCorporateSuccess(result));
      toast.success(result.message);
      if (redirect) {
        yield put(setRedirect('CorporateRegister'));
      }
    } else if (result.error) {
      toast.error(result.error);
      yield put(createCorporateError(result.error));
    }
  } catch (e) {
    if (e.error) toast.error(e.error);
    yield put(createCorporateError(e));
  }
}

function* rootSagas() {
  yield takeLatest(sagaActions.FETCH_USER_BY_UUID, fetchUserByUUIDSaga);
  yield takeLatest(sagaActions.CREATE_USER, createUserSaga);
  yield takeLatest(sagaActions.CREATE_CORPORATE, createCorporateSaga);
}

export default rootSagas;
